import { render, staticRenderFns } from "./modalEventForm.vue?vue&type=template&id=28588c22&scoped=true"
import script from "./modalEventForm.vue?vue&type=script&lang=js"
export * from "./modalEventForm.vue?vue&type=script&lang=js"
import style0 from "./modalEventForm.vue?vue&type=style&index=0&id=28588c22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28588c22",
  null
  
)

export default component.exports